export default "https://cdn-gra-staging.amplement.io/statics/images/file/file-mp3.svg";